// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"3bb7cd5b","159":"466febb4","223":"af47198b","393":"82713b54","931":"5aa7ecf1"}[chunkId] + ".chunk.js";
};